import { useDedupEffect } from "./useDedupEffect";
import { fetchResources,response } from "services/fetchResources";
import { environment, getOnlineServices, isLocalhost } from "util/index";
import { useDispatch, useSelector } from "react-redux";
import { createFailureAction, createSetConfigAction, createSetContentAction, createSetUpdateManfiestAction, createSetViewAction } from "state/reducer";
import { indexDBStorage } from "storage/indexDBStorage";
import TimeService from "../services/timeService";
import { AppConfigExtended, IADPState, ManifestProps } from "../Types/AppStateTypes";
import { useIPCBridge } from "./useIPCBridge";
import { serviceWorkerRegistration } from "../services/serviceWorkerRegistration";
import { useBatteryService } from "./useBatteryService";
import { useNetworkService } from "./useNetworkService";
import {DetectCaptivePortal} from "../services/captivePortalDetectionService"
import { CheckCacheResources } from "../services/checkCachedResources";

export function useInitilizeApp() {
    const dispatch = useDispatch();
    useBatteryService();
    useNetworkService();
    const state = useSelector((state:{rootState:IADPState})=>state.rootState)
    const {sendGreeting,getReleaseVersion} = useIPCBridge();
    async function fetchAppData():Promise<boolean> {
        try {
            serviceWorkerRegistration().registerSW().then((value)=>{
                console.log("serviceWorkerRegistration",value);
                CheckCacheResources(["config.json"],state.appState.appVersion)
            });
            let promises = [];
            let configuration:AppConfigExtended;
            const fetchConfig = new Promise<response>(async (resolve) => {
                const configData = await fetchResources(`${environment.resovleAppDomain()}config/config.json`);
                configuration = configData.data;
                dispatch(createSetConfigAction(configData.data))
                   resolve(configData);
                })
            const fetchADEBuildJson = new Promise<response>(async (resolve) => {
                const configData = await fetchResources(`${environment.resolveENAEPDomain()}/ade/build.json`);
                resolve(configData);
            });
            const fetchSCIBuildJson = new Promise<response>(async (resolve) => {
                const configData = await fetchResources(`${environment.resolveENAEPDomain()}/login/build.json`);
                resolve(configData);
            });
            const fetchADPBuildJson = new Promise<response>(async (resolve) => {
                const configData = await fetchResources(`${environment.resovleAppDomain()}build.json`);
                resolve(configData);
            });       
            const fetchManifest = new Promise<response>(async (resolve) => {
                const manifestData = await fetchResources(`${environment.resovleAppDomain()}manifest/naep.manifest.json`);
                try{
                    const appReleaseVersion = await getReleaseVersion()//TODO -compare build numbers, display version for one that is greater
                    //const updateRecord = await (await indexDBStorage.getInstance()).transactions.get("adp-session-references","localReleaseVersion");
                    const version = appReleaseVersion ?? manifestData?.data?.manifest.product?.version
                    await (await indexDBStorage.getInstance()).transactions.put("adp-session-references",version,"localReleaseVersion"); 
                    if(manifestData?.data?.manifest.product?.version){
                        manifestData.data.manifest.product.version = version;
                        dispatch(createSetUpdateManfiestAction(manifestData.data))
                    }
                }
                catch(e){
                    console.warn("error updating release version in indexDB");
                } 
                    resolve(manifestData);
                })
            const fetchLocales = new Promise<response>(async (resolve) => {
                const enData = await fetchResources(`${environment.resovleAppDomain()}locale/en.json`);
                indexDBStorage.getInstance().then((instance:any)=>{
                    instance.transactions.put("adp-session-references",enData.data,"content-en");
                  });
                const esData = await fetchResources(`${environment.resovleAppDomain()}locale/es.json`);
                indexDBStorage.getInstance().then((instance:any)=>{
                    instance.transactions.put("adp-session-references",esData.data,"content-es");
                  });
                dispatch(createSetContentAction({en:enData.data,es:esData.data}));
                    resolve(enData);
                })
            promises.push(fetchConfig);
            promises.push(fetchManifest);
            promises.push(fetchLocales);
            promises.push(fetchADPBuildJson);
            if(!isLocalhost){
            promises.push(fetchADEBuildJson);
            promises.push(fetchSCIBuildJson); 
            }
           
            const isFetchSuccess = await Promise.all(promises).then(async(values) => {
                const responseError = values.find((val)=>{return val.error});
                if(responseError) {
                    dispatch(createSetViewAction("WarningView"));
                    return false;
                }
                if(navigator.onLine){
                const onlineURL =`${environment.resolveApiDomain(configuration)}/${getOnlineServices(configuration)?.cloudServiceHealth}`;
                // const onlineURL = `https://enaep.dev25.npdng.org/${getOnlineServices(configuration)?.cloudServiceHealth}`;
                console.log('onlineURL', onlineURL);
                const timeInSync = await TimeService.validateCurrentTime(onlineURL,state?.appState.configuration?.DeviceValidation.checkSystemClock.threshold || 300000)
                
                if(!timeInSync.passed){
                    if(timeInSync.serverTime?.includes("ErrorFetchingDate")){
                        dispatch(createFailureAction("NoServerConnectionDetected"));
                    }
                    else {
                        dispatch(createFailureAction("FailedSystemTimeCheck"));
                    }
                    return false  
                }
                return true
                //TODO - replace with microsoft HTTP endpoints
                //TODO - store in indexDB and submit as part of the logs, warning - no clientLaunchId or other dettails are available at this time. 
                }
                else {
                    dispatch(createFailureAction("NoInternetConnectionDetected"));
                    return false;
                }
                
            })
            return isFetchSuccess;  
        }
        catch(e)
        {
            console.log("Error initiliziing app", e);
            dispatch(createSetViewAction("WarningView"));
            return false;
        }       
    }
    useDedupEffect(() => {
        DetectCaptivePortal('',`build.json`,'@npd-ng/adp-web-app' ).then((response)=>{
            if(response?.isCaptivate || response?.error){
                dispatch(createSetViewAction("WarningView"));   
                return;
               }
               else {
                fetchAppData().then(async (isSuccess)=>{
                    if(isSuccess){
                        sendGreeting();
                    }
                    else {
                        dispatch(createSetViewAction("WarningView"));   
                    }
                });  
               }
            })
    },[]);
};
